if (!customElements.get("sqli-marquee-slider")) {
  customElements.define(
    "sqli-marquee-slider",
    class SqliMarqueeSlider extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        const wrapperSelector = this.dataset.wrapperSelector;
        const itemsSelector = this.dataset.itemSelector;
        const innerSelector = this.dataset.innerSelector;
        this.speedPixelsPerSecond = parseInt(this.dataset.speed) || 100;
        this.speedPixelsPerSecondHover = parseInt(this.dataset.hoverSpeed) || 100;
        
        this.wrapper = this.querySelector(wrapperSelector);
        this.inner = this.querySelector(innerSelector);
        this.items = this.querySelectorAll(itemsSelector);

        this.offset = 0;
        
        this.mouseEnterHandler = () => {
          this.stopScrolling();
          this.startScrolling(this.speedPixelsPerSecondHover);
        };
      
        this.mouseLeaveHandler = () => {
          this.stopScrolling();
          this.startScrolling(this.speedPixelsPerSecond);
        };

        this.wrapper.addEventListener('mouseenter', this.mouseEnterHandler);
        this.wrapper.addEventListener('mouseleave', this.mouseLeaveHandler);
        
        this.cloneItems();
        this.cloneItems();
        this.cloneItems();
        this.startAnimation();
      }

      disconnectedCallback() {
        if (this.wrapper) {
          this.wrapper.removeEventListener('mouseenter', this.mouseEnterHandler);
          this.wrapper.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      cloneItems() {
        this.items.forEach((item) => {
          const clone = item.cloneNode(true);
          this.inner.appendChild(clone);
        });
      }
      startAnimation() {
        this.startScrolling(this.speedPixelsPerSecond);
      }
      startScrolling(speedPxPerSec) {
        this.speed = speedPxPerSec;
        this.lastTimestamp = null;
      
        const step = (timestamp) => {
          if (!this.lastTimestamp) this.lastTimestamp = timestamp;
          const delta = (timestamp - this.lastTimestamp) / 1000; // time since the last frame in seconds
          this.lastTimestamp = timestamp;
      
          this.offset -= this.speed * delta;
      
          // if scrolled to the half -> reset (for looking like endless loop)
          const resetAt = this.inner.scrollWidth / 2;
          if (Math.abs(this.offset) >= resetAt) {
            this.offset = 0;
          }
      
          this.inner.style.transform = `translateX(${Math.ceil(this.offset)}px)`;
          this.raf = requestAnimationFrame(step);
        };
      
        this.raf = requestAnimationFrame(step);
      }
      stopScrolling() {
        cancelAnimationFrame(this.raf);
      }
    }
  );
}